/** Mensagem de "integração não configurada" — detalhe técnico (variável de
 * ambiente, caminho de doc) só para quem pode realmente configurar o servidor.
 * Gerente vê um aviso simples apontando pro superadmin. */
export function integrationNotConfiguredNotice(
  feature: string,
  envVar: string,
  isSuperadmin: boolean,
): string {
  if (isSuperadmin) {
    return `${feature} ainda não configurada — falta ${envVar} no servidor (ver docs/INTEGRACOES-EXTERNAS.md).`;
  }
  return `${feature} ainda não configurada. Fale com o Naldo para ativar essa integração.`;
}
